// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1hqtw","checkboxCol":"Table_checkboxCol__1fC9T","emailCol":"Table_emailCol__DAZkh","actionCol":"Table_actionCol__impGV"};